module.exports = __webpack_public_path__ + "img/57f2bb8.jpg";